import React from "react"

const PostImage = ({ img }) => {
  return (
    <div className="singlePost__content__img">
      <img src={img} alt="" />
    </div>
  )
}

export default PostImage
